import { type DocumentArticle, type DocumentDefault, type DocumentKey, themes } from "../materials/theme";
import { O, pipe } from "../prelude";
import { findArticleAlias } from "../routes";
import { useActiveAlias } from "./useActiveAlias";

export function useActiveTheme(): DocumentArticle | DocumentDefault {
  const alias = useActiveAlias();
  const themeKey = pipe(
    findArticleAlias(alias),
    O.getOrElse((): DocumentKey => "default"),
  );
  return themes[themeKey];
}
